// Persistent layout: terminal-styled header + outlet.

import { auth } from '../core/auth.js';
import { api } from '../core/api.js';
import { esc } from '../core/component.js';

const ADMIN_TITLE = 'NESTLY ADMIN TERMINAL';
const ADMIN_VERSION = 'v1.0';

export class AppShell {
  constructor(root) {
    this.root = root;
    this.outlet = null;
    this._unsubAuth = null;
  }

  mount() {
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.lang = 'en';
    }
    this.root.innerHTML = `
      <div class="app-shell">
        <header class="terminal-header">
          <div class="terminal-brand">
            <span class="brand-icon">▣</span>
            <span class="brand-title">${ADMIN_TITLE}</span>
            <span class="brand-version">${ADMIN_VERSION}</span>
          </div>
          <div class="terminal-status">
            <span class="status-time" data-slot="time"></span>
            <span class="status-item" data-role="user-info" hidden>
              <span class="user-prompt">$</span>
              <span class="user-email" data-slot="user-email"></span>
            </span>
            <button type="button" class="terminal-btn-logout" data-action="logout" hidden>
              [LOGOUT]
            </button>
          </div>
        </header>
        <main class="app-main" id="outlet"></main>
      </div>
    `;
    this.outlet = this.root.querySelector('#outlet');

    this.root.querySelector('[data-action="logout"]').addEventListener('click', () => {
      this._signOut();
    });

    this._updateTime();
    setInterval(() => this._updateTime(), 1000);
    this._renderAuthState(auth.state);
    this._unsubAuth = auth.subscribe((state) => this._renderAuthState(state));
  }

  _updateTime() {
    const timeEl = this.root.querySelector('[data-slot="time"]');
    if (timeEl) {
      const now = new Date();
      timeEl.textContent = now.toISOString().slice(0, 19).replace('T', ' ');
    }
  }

  async _signOut() {
    try { await api.post('/auth/logout'); } catch (_) {}
    auth.clear();
    window.location.hash = '#/login';
  }

  setActiveTab(path) {
    // Admin doesn't use tabs, but method exists for router compatibility
  }

  _renderAuthState(state) {
    const isAuthed = !!state.accessToken || state.user?.role === 'ADMIN';
    const userInfo = this.root.querySelector('[data-role="user-info"]');
    const logoutBtn = this.root.querySelector('[data-action="logout"]');
    const emailEl = this.root.querySelector('[data-slot="user-email"]');
    if (userInfo) userInfo.hidden = !isAuthed;
    if (logoutBtn) logoutBtn.hidden = !isAuthed;
    if (emailEl && state.user) emailEl.textContent = state.user.email || '';
  }
}